// extracted by mini-css-extract-plugin
export default {"smallVendorCardList":"smallVendorCardList__ODE3Y","smallVendorCardWrapper":"smallVendorCardWrapper__ZjJiM"};